import * as React from 'react';
import styles from './LoginLoader.css';
import logo from '../images/mursion-mark-1024.png';


export default class LoginLoader extends React.Component<any> {

  public render() {
    return (
      <div className={styles.loader}>
        <div className={styles.loaderBackdrop}/>
        <div className={styles.loaderDots}>
          <div className={styles.d01}/>
          <div className={styles.d02}/>
          <div className={styles.d03}/>
        </div>
        <img className={styles.iconM} src={logo} alt={''}/>
      </div>
    );
  }
}

